import axios from 'axios';
import 'url-search-params-polyfill';

//we define a beginning of a visit the moment when the referrer is not ourselves
const isBeginningOfVisit = (excludedUrls, referrer) => {
  if (!referrer) {
    return true; //typed in browser or bookmark
  }

  const filtered = excludedUrls.filter(el => {
    return referrer.indexOf(el) !== -1;
  });

  //if referrer is one of the excluded url we don't report a hit - internal navigation
  return filtered.length === 0;
};

const trackVisit = (basePathWeb, basePathAdmin, basePathSecure, basePathAccount) => {
  const referrer = document.referrer;

  const search = window.location.search;
  const urlParams = new URLSearchParams(search);

  const semboxSource = urlParams.get('sembox_source');
  const utmSource = urlParams.get('utm_source');
  const utmContent = urlParams.get('utm_content');

  const excludedUrls = [basePathWeb, basePathAdmin, basePathSecure, basePathAccount];
  const beginning = isBeginningOfVisit(excludedUrls, referrer);

  if (beginning) {
    axios.post('/api/visit/', {
      semboxSource,
      utmSource,
      utmContent,
      referrer
    });
  }
};

export default trackVisit;
